import React from 'react';
import { Card } from '../ui/Card';
import { Select } from '../ui/Select';
import { Input } from '../ui/Input';
import { useWizard } from '../../hooks/useWizard';
export function WizardStep3Access() {
  const {
    data,
    updateStep3
  } = useWizard();
  const step3Data = data.step3;
  return <Card title="Access Control" description="Who can view and order from this store?" data-id="element-492">
      <div className="space-y-6" data-id="element-493">
        <Select label="Store Access Type" value={step3Data.accessType} onChange={e => updateStep3({
        accessType: e.target.value as any
      })} options={[{
        value: 'public',
        label: 'Public (Anyone with link)'
      }, {
        value: 'password',
        label: 'Password Protected'
      }, {
        value: 'code',
        label: 'Access Code Required'
      }]} data-id="element-494" />

        {step3Data.accessType === 'password' && <Input label="Store Password *" type="text" placeholder="Enter password" value={step3Data.password} onChange={e => updateStep3({
        password: e.target.value
      })} data-id="element-495" />}

        {step3Data.accessType === 'code' && <Input label="Access Code *" type="text" placeholder="Enter access code" value={step3Data.accessCode} onChange={e => updateStep3({
        accessCode: e.target.value
      })} data-id="element-496" />}

        <div className="border-t border-gray-200 pt-6" data-id="element-497">
          <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-498">
            Limit to Specific Emails (Optional)
          </label>
          <p className="text-xs text-gray-500 mb-2" data-id="element-499">
            Enter one email per line. If set, only these emails can access the
            store.
          </p>
          <textarea className="w-full rounded-md border border-gray-300 p-2 text-sm focus:ring-red-500 focus:border-red-500" rows={5} placeholder="john@example.com&#10;jane@example.com" value={step3Data.allowedEmails} onChange={e => updateStep3({
          allowedEmails: e.target.value
        })} data-id="element-500" />
        </div>
      </div>
    </Card>;
}